import type { Theme, Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

const MuiCard: Components<Theme>['MuiCard'] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme }) => ({
      position: 'relative',
      boxShadow: theme.vars.customShadows.card,
      borderRadius: theme.shape.borderRadius * 2,
      zIndex: 0, // Fix Safari overflow: hidden with border radius
    }),
  },
};

// ----------------------------------------------------------------------

const MuiCardHeader: Components<Theme>['MuiCardHeader'] = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: {
    // Cabeçalho do `.card` do canvas: h2 16px/700 + p 12px (§8 T8).
    titleTypographyProps: { variant: 'subtitle1', fontWeight: 700 },
    subheaderTypographyProps: { variant: 'caption', color: 'text.secondary', marginTop: '4px' },
  },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: { root: ({ theme }) => ({ padding: theme.spacing(3, 3, 0) }) },
};

// ----------------------------------------------------------------------

const MuiCardContent: Components<Theme>['MuiCardContent'] = {
  /** **************************************
   * STYLE
   *************************************** */
  // O `.card` genérico do canvas declara padding 16px (§8 T8). O `&:last-child` é
  // obrigatório: `CardContent.js:32-34` declara `'&:last-child': { paddingBottom: 24 }`,
  // seletor (0,2,0) que vence o bloco plano do `styleOverrides.root` (0,1,0) — sem ele
  // o último (quase sempre o único) `CardContent` ficaria 16/16/24/16.
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2),
      '&:last-child': { paddingBottom: theme.spacing(2) },
    }),
  },
};

// ----------------------------------------------------------------------

export const card = { MuiCard, MuiCardHeader, MuiCardContent };
